import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import en from './locales/en.json';
import it from './locales/it.json';
import es from './locales/es.json';

const resources = {
  en: { translation: en },
  it: { translation: it },
  es: { translation: es }
};

// Safely get language from localStorage
let savedLanguage = 'it';
try {
  savedLanguage = localStorage.getItem('language') || 'it';
} catch (e) {
  console.warn('Could not access localStorage, using default language');
}

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: savedLanguage,
    fallbackLng: 'it',
    interpolation: {
      escapeValue: false
    },
    react: {
      useSuspense: false
    },
    debug: false // Cambia a true per debug
  });

export default i18n;
